import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Global, css } from '@emotion/react';
import { authSelectors } from 'redux/auth';

const duration = 600;

// html:root outranks MUI's single-class rules; inline transitions (Collapse, Fade) still win
const styles = css`
  html:root *,
  html:root *::before,
  html:root *::after {
    transition-property: background-color, color, border-color, fill, stroke;
    transition-duration: ${duration}ms;
    transition-timing-function: ease;
  }
`;

// The workspace color arrives with auth, so colors fade from the brand default instead of jumping
const ThemeColorTransition = () => {

  const isLoggedIn = useSelector(authSelectors.getUserIsLoggedIn);

  const [isSettling, setIsSettling] = useState(true);

  useEffect(() => {
    if (isLoggedIn === null) {
      return undefined;
    }

    const timeout = setTimeout(() => setIsSettling(false), duration * 2);
    return () => clearTimeout(timeout);
  }, [isLoggedIn]);

  return isSettling ? <Global styles={styles} /> : null;
};

export default ThemeColorTransition;
